export default "__VITE_PUBLIC_ASSET__08ad3409__"